var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaKosmetik(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#606572;}.cls-3{fill:#3b4254;}.cls-4{fill:#f7cf9c;}.cls-5{fill:#e6af78;}.cls-6{fill:#fcd249;}.cls-7{fill:#fee9a1;}.cls-8{fill:#fdca67;}.cls-9{fill:#dda84a;}.cls-10{fill:#fd7ba2;}.cls-11{fill:#e9488e;}.cls-12{fill:#ff7870;}.cls-13{fill:#d7352e;}.cls-14{fill:#eff2fa;}.cls-15{fill:#c7cfe2;}.cls-16{fill:#ff9794;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.47,134.85H63.35A37.37,37.37,0,0,1,26,97.48V54.43A46.43,46.43,0,0,1,72.41,8h0a46.43,46.43,0,0,1,46.43,46.43V97.48A37.37,37.37,0,0,1,81.47,134.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.41,8h0c-1.22,0-2.43.05-3.62.14a46.44,46.44,0,0,1,42.8,46.29V97.48a37.37,37.37,0,0,1-37.37,37.37h7.25a37.37,37.37,0,0,0,37.37-37.37V54.43A46.43,46.43,0,0,0,72.41,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.18,141.12H32.51l.67-10.66A18.15,18.15,0,0,1,47,114l11.58-2.87a1.27,1.27,0,0,0,1-1.24V84H85.32V109.9a1.29,1.29,0,0,0,1,1.25L97.74,114a18.17,18.17,0,0,1,13.77,16.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M111.51,130.46A18.17,18.17,0,0,0,97.74,114L86.3,111.15a1.29,1.29,0,0,1-1-1.25V84H78.76V109.9a1.29,1.29,0,0,0,1,1.25L91.17,114a18.17,18.17,0,0,1,13.77,16.49l.67,10.66h6.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M59.5,105.62a27.59,27.59,0,0,0,12.91,3.57,27.59,27.59,0,0,0,12.91-3.57V84H59.5v21.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.71,70.16c-4,20.54-20.61,32.37-33.3,32.37C60.46,102.53,45,92,39.94,73.65c22.71-3.24,41.86-24.3,46.65-36.52C86.59,37.13,86.59,64.05,105.71,70.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M97,65C96,87.49,81.77,101.1,70.32,102.42c.71.07,1.41.11,2.09.11,12.69,0,29.29-11.83,33.3-32.37A22.52,22.52,0,0,1,97,65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111,18c-1.58,5.81-3.77,8-9.58,9.58a1.23,1.23,0,0,0,0,2.37c5.81,1.58,8,3.77,9.58,9.58a1.22,1.22,0,0,0,2.36,0c1.58-5.81,3.77-8,9.58-9.58a1.23,1.23,0,0,0,0-2.37c-5.81-1.58-8-3.77-9.58-9.58A1.22,1.22,0,0,0,111,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M121.5,109.28l-15.16-14a5.28,5.28,0,0,1,1.78-8.84l18.68-6.8a5.28,5.28,0,0,1,7,5.63l-2.61,20.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M126.8,79.64l-4.73,1.72c3-1.08,6.32,2.15,6.16,6l-.83,19.82,3.84-1.39,2.61-20.47A5.28,5.28,0,0,0,126.8,79.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M127.62,86.88a19.85,19.85,0,0,0-2.51-6.63L121,81.74a14.64,14.64,0,0,1,2.43,5.87l1,5.47a2.11,2.11,0,1,0,4.15-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M112.15,92.51l2.79,4.81a2.1,2.1,0,0,0,1.82,1.05,2.11,2.11,0,0,0,1.83-3.17l-2.79-4.8a14.66,14.66,0,0,1-1.91-6.07l-4.08,1.49A19.88,19.88,0,0,0,112.15,92.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M120.73,110.74l8.41,23.11a6.4,6.4,0,0,0,8.21,3.82h0a6.4,6.4,0,0,0,3.82-8.2l-8.41-23.11a2.12,2.12,0,0,0-2.74-1.28L122,108A2.15,2.15,0,0,0,120.73,110.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M141.17,129.47l-8.41-23.11a2.12,2.12,0,0,0-2.74-1.28l-4.18,1.52c.65-.24,1.5.47,1.91,1.58l8.41,23.11c1,2.78.76,5.51-.48,6.75a6.78,6.78,0,0,0,1.67-.37h0A6.4,6.4,0,0,0,141.17,129.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.04 115.37 134.6 111.4 134.6 111.4 122.56 115.78 122.56 115.78 124.01 119.75 124.01 119.75 136.04 115.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "134.6 111.4 129.58 113.23 131.03 117.19 136.04 115.37 134.6 111.4 134.6 111.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M40.46,99.83V120.6H21.32V91a2,2,0,0,1,.24-1C22.75,88,27.89,88.73,33,91.7,37.46,94.25,40.46,97.62,40.46,99.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M34,92.31V120.6h6.42V99.83C40.46,97.79,37.91,94.77,34,92.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M40.48,120.6H21.3a2.85,2.85,0,0,0-2.85,2.85v25.7A2.86,2.86,0,0,0,21.3,152H40.48a2.85,2.85,0,0,0,2.84-2.85v-25.7A2.84,2.84,0,0,0,40.48,120.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M40.48,120.6H34.06a2.85,2.85,0,0,1,2.85,2.85v25.7A2.85,2.85,0,0,1,34.06,152h6.42a2.85,2.85,0,0,0,2.84-2.85v-25.7A2.84,2.84,0,0,0,40.48,120.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M40.46,99.83a1.85,1.85,0,0,1-.25,1c-1.19,2.06-6.33,1.32-11.47-1.66-4.43-2.55-7.42-5.92-7.42-8.13a2,2,0,0,1,.24-1C22.75,88,27.89,88.73,33,91.7,37.46,94.25,40.46,97.62,40.46,99.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.45,
    y: 127.08,
    width: 24.87,
    height: 4.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 36.91,
    y: 127.08,
    width: 6.41,
    height: 4.22
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaKosmetik);
export default __webpack_public_path__ + "static/media/ka_kosmetik.aed7a8f85fb7f49e5c69744861a35055.svg";
export { ForwardRef as ReactComponent };